import React from "react";
import { Link } from "react-router-dom";

const TopicOne = () => {
  return (
    <div className="quality-section-market">
      <div className="quality-header-market">
        <h1>
          How to determine if a client is entitled dividend from Index AUS200?
        </h1>
        <p>
          Dividend adjustments depend on holding positions before ex-dividend
          dates. A client with 1 lot of BUY for AUS200 is entitled to $2.44 per
          lot, while a SELL position is debited $2.44.
        </p>
      </div>
    </div>
  );
};

export default TopicOne;
